import type {ReactElement} from 'react';
import {Icon} from '@Components/icon-v2/icon';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {EMAIL_MAKER_DEVICE_ICON, EMAIL_MAKER_DEVICE_LABEL_KEY, EMAIL_MAKER_SWITCHER_DEVICES} from './device-switcher.types';
import type {DeviceSwitcherProps} from './device-switcher.types';
import styles from './device-switcher.module.scss';

export function DeviceSwitcher({currentDevice, onSelect}: DeviceSwitcherProps): ReactElement {
  return (
    <div className={styles.devicePill}>
      {EMAIL_MAKER_SWITCHER_DEVICES.map((device) => (
        <button
          key={device}
          aria-label={window.i18next.t(EMAIL_MAKER_DEVICE_LABEL_KEY[device])}
          aria-pressed={currentDevice === device}
          className={styles.deviceButton}
          onClick={(): void => {
            onSelect(device);
          }}
          type="button"
        >
          <Icon icon={EMAIL_MAKER_DEVICE_ICON[device]} shape={IconShape.CIRCLE} type={IconType.GHOST} size={IconSize.SIZE_ICON_20} isSelected={currentDevice === device} />
        </button>
      ))}
    </div>
  );
}
